import { createAsyncThunk } from '@reduxjs/toolkit';
import { postSendInstalmentTableApproval } from 'store/saleInvoices/services/postSendInstalmentTableApproval';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';

// One call: the backend sets status PENDING, creates the approval token and
// sends the approval email. Returns { approvalId, instalmentTable }.
export const sendInstalmentTableToApproval = createAsyncThunk(
  'saleInvoices/sendInstalmentTableToApproval',
  async ({ tableId, email }, { getState }) => {
    if (!tableId) {
      throw new Error('No instalment table id provided');
    }

    const selectedProjectId = selectSelectedProjectId(getState());

    const response = await postSendInstalmentTableApproval(
      selectedProjectId,
      tableId,
      email
    );

    return response;
  }
);
